export const SENDING_TELEPHONE = 'auth/signup/phone_send_phone';
export const SENDING_TELEPHONE_SUCCESS = 'auth/signup/phone/send_phone_success';
export const SENDING_TELEPHONE_ERROR = 'auth/signup/phone/send_phone_error';
